const commonStyles = `
    cursor: text;
    border-radius: 3px;
    border: 1px solid rgb(175, 177, 190);
    box-shadow: 0px 1px 3px rgba(153, 155, 162, 0.2);
    width: 100%;
    padding: 0 14px;
    
    color: var(--blue-dark);

    &:focus {
      border-color: var(--blue-light);
      box-shadow: 0 0 0 4px rgba(5, 127, 206, 0.1);
      outline: none;
    }

    &:disabled {
     background: var(--gray-light);
     cursor: not-allowed;
    }
    
    ::placeholder {
        color: rgb(147, 150, 162);
    }
`;

const errorStyles = `
    border-color: var(--red);
    &:focus {
      box-shadow: 0 0 0 4px rgba(234, 65, 65, 0.1);
      border-color: var(--red);
    }
`;

export { commonStyles, errorStyles };
